import { Input, Component } from '@angular/core';

export interface TabInfo {
    displayString: string;
    isActive: Function;
    isDisabled?: boolean;
    onClick?: Function;
    routerLink?: {
        location: string;
        options?: any;
        fragment?: string;
    };

    infoTooltip?: string;
    disabledTooltip?: string;
}

@Component({
    selector: 'tab-navigator',
    template: `
        <ul class="tabNavigationList" [ngClass]="listClassModifiers">
            <ng-content></ng-content>
        </ul>
    `,
    standalone: false
})
export class TabNavigatorComponent {
    @Input()
    tabsList: TabInfo[];
    @Input()
    listClassModifiers: string;
}
